<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="grey-page">
		<section class="container-small applicants-list">
			<h3 class="page__main-title">Owners</h3>
			<br>
			Your owner registration public link:<br />
			<a :href="ownerRegistrationUrl" target="_blank">{{ownerRegistrationUrl}}</a>
			<br /><br />

			<a :href="ownerRegistrationUrl" target="_blank" class="mdc-button mdc-button--raised">Add Owner</a>

			<br /><br />
      <div class="mdc-textfield mdc-textfield--fullwidth mdc-text-field--dense mdc-textfield--with-trailing-icon mdc-ripple-upgraded">
        <input id="search" class="mdc-textfield__input marketplace-header__search-input" type="text" placeholder="Search..." v-model="search"/>
        <i class="mdc-textfield__icon ico ico-search"></i>
      </div>
      <!--
			<div class="applicants-list__filters mdc-tab-bar mdc-tab-bar-upgraded">
				<a href="#one" class="applicants-list__filter mdc-tab mdc-ripple-upgraded" :class="{'mdc-tab--active applicants-list__filter--active': isSales}" @click="toggleOwners('sales')">Sales</a>
				<a href="#two" class="applicants-list__filter mdc-tab mdc-ripple-upgraded" :class="{'mdc-tab--active applicants-list__filter--active': isLettings}" @click="toggleOwners('lettings')">Lettings</a>
        <a href="#three" class="applicants-list__filter mdc-tab mdc-ripple-upgraded" :class="{'mdc-tab--active applicants-list__filter--active': isNull}" @click="toggleOwners('null')">No search criteria</a>
				<span class="mdc-tab-bar__indicator applicants-list__filter-indicator" :class="{'applicants-list__filter-indicator--two': isLettings,'applicants-list__filter-indicator--three': isNull}"></span>
			</div>
    -->
			<div v-if="!ownersLoaded" class="margin-top-60 text-center">
				<p class="mdc-theme-primary-dark loading-text">Loading Owners<span>.</span><span>.</span><span>.</span></p>
			</div>
			<div v-if="ownersLoaded" class="applicants-list">
				<!-- Sale Owners
				<owner-box v-for="(owner, index) in owners" v-if="owner.serviceType == '1' && isSales" :owner="owner" :key="owner.mobile" :arrayIndex="index" v-model="owners"></owner-box>-->
        <!-- To Let Owners
				<owner-box v-for="(owner, index) in owners" v-if="owner.serviceType == '2' && isLettings" :owner="owner" :key="owner.mobile" :arrayIndex="index" v-model="owners"></owner-box>-->
        <!-- All other Owners v-if="(!owner.serviceType || owner.serviceType === true) && isNull"  -->
				<owner-box v-for="(owner, index) in owners" :owner="owner" :key="owner.mobile" :arrayIndex="index" v-model="owners"></owner-box>
			</div>
		</section>

		<!-- Add Property Button -->
		<figure class="btn-add-property--fixed">
			<a :href="ownerRegistrationUrl" target="_blank" class="mdc-fab material-icons mdc-ripple-upgraded"><i class="ico-plus_math mdc-fab__icon"></i></a>
		</figure>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import OwnerBox from '../components/OwnerBox.vue';

export default {
	data: function() {
		return {
			owners: [],
      allowners: [],
			ownersLoaded: false,
			isSales: true,
      isLettings: false,
      isNull: false,
      search: ''
		}
	},
	components: {
		'owner-box': OwnerBox
	},
	created: async function() {
		this.owners = await api({endpoint: this.config.services.owners, path: '/', method: 'GET'});
    console.log('this.owners',this.owners);
    this.owners.sort((a, b) => a.fullName.trim().substr(0,1).toLowerCase() < b.fullName.trim().substr(0,1).toLowerCase() ? -1 : 1);
    this.allowners = this.owners;
		this.ownersLoaded = true;
	},
  watch: {
		search: function() {
			this.liveSearch(this.search);
		},
  },
	methods: {
    liveSearch: function(txt) {
      if (!txt || txt == '') {
        txt = this.search;
      }
      if (!txt || txt == '') {
        this.owners = this.allowners;
        return true;
      }
      txt = txt.toLowerCase();
      this.owners = this.allowners.filter(o => {
        return (o.fullName && o.fullName.toLowerCase().indexOf(txt) !== -1) || (o.email && o.email.toLowerCase().indexOf(txt) !== -1);
      });
    },
		firstName(fullname) {
			return fullname.split(' ')[0];
		},
		getType(type) {
			if(type == 'flat') {
				return 'Flat';
			} else if(type == 'house') {
				return 'House';
			} else if(type == 'either') {
				return 'Flat & House';
			} else {
				return '--';
			}
		},
		getConsent(applicant) {
			let consent = '';
			if(applicant.email) {
				consent = 'Email';
			}
			if(applicant.mobile) {
				if(consent.length > 0) {
					consent += ' & ';
				}
				consent += 'Mobile';
			}
			return consent;
		},
		toggleOwners: async function(type) {
			this.ownersLoaded = false;
      if (type == 'sales') {
        this.isSales = true;
        this.isLettings = false;
        this.isNull = false;
      } else if (type == 'lettings') {
        this.isSales = false;
        this.isLettings = true;
        this.isNull = false;
      } else {
        this.isSales = false;
        this.isLettings = false;
        this.isNull = true;
      }
			this.owners = await api({endpoint: this.config.services.owners, path: '/', method: 'GET'});
      this.owners.sort((a, b) => a.fullName.trim().substr(0,1).toLowerCase() < b.fullName.trim().substr(0,1).toLowerCase() ? -1 : 1);
			this.ownersLoaded = true;
		},
	},
	mixins: [utils],
	computed: {
		ownerRegistrationUrl() {
			let companyId;
			if (this.$store.getters.adminCompanyId && this.$store.getters.adminCompanyId !== this.$store.getters.companyId) {
				companyId = this.$store.getters.adminCompanyId;
			} else {
				companyId = this.$store.getters.companyId;
			}
			return `${process.env.BASE_URL}/registerowner/${companyId}`;
		}
	}
}
</script>

<style>
.applicants-list__filter-indicator {
  width: 60%
}
.applicants-list__filter-indicator--two {
  -webkit-transform: translateX(50%) scale(0.5, 1);
  transform: translateX(50%) scale(0.5, 1);
}
.applicants-list__filter-indicator--three {
  -webkit-transform: translateX(100%) scale(0.7, 1);
  transform: translateX(100%) scale(0.7, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Owners.vue